import { Outlet } from "react-router-dom";
import { Brand } from "@/components/Brand";
import { SiteFooter } from "@/components/SiteFooter";

// The marketing/public shell: a sticky Brand header, the routed page in <main>,
// and the shared footer. Used for the splash, the auth flows, and the in-app
// 404 — the pre-login surface. The authenticated post-login chrome (left nav +
// account menu) lives in PortalShell (BRK-S035). Mobile-first: unprefixed
// classes describe the 375px layout; `sm:` widens it, and the `mx-auto max-w-*`
// wrappers prevent horizontal overflow at every breakpoint.
//
// The route → document.title mapping is owned one level up in RootLayout, so
// this shell no longer touches document.title (BRK-S031).
export function AppShell() {
  return (
    <div className="flex min-h-full flex-col bg-brk-ink text-white">
      <header className="sticky top-0 z-10 border-b border-white/10 bg-brk-ink/90 backdrop-blur">
        <div className="mx-auto flex w-full max-w-5xl items-center justify-between px-4 py-5 sm:px-6 sm:py-6">
          <Brand size="sm" />
        </div>
      </header>

      <main className="mx-auto w-full max-w-5xl flex-1 px-4 py-8 sm:px-6 sm:py-12">
        <Outlet />
      </main>

      <SiteFooter />
    </div>
  );
}
